import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'layout-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.scss'],
})
export class CardsComponent implements OnInit {
  public cardInfo = [];
  constructor() {
    this.cardInfo = [
      {
        type: 'Persona Natural',
        icon: '../../../../assets/icons/entrepreneur.svg',
        title: 'Soy un emprendedor',
        description:
          'Si eres emprendedor persona natural que facture menos de 100 millones de pesos al mes y deseas recibir pagos en línea.',
        button_text: 'Abre tu cuenta',
        button_url: '',
      },
    ];
  }

  ngOnInit(): void {}
}
